import React, { useEffect, useState } from "react";
import "./faqs.scss";
import { Collapse, Divider, Grid, Stack } from "@mui/material";
import { FAQs_Data } from "../../constant";

const QuestionsAnswer = ({ QA }) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <div className="single-question-answer">
      <div className="question" onClick={() => setExpanded(!expanded)}>
        {QA.question}
      </div>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <div className="answer">{QA.answer}</div>
      </Collapse>
    </div>
  );
};

const Faqs = () => {
  return (
    <div className="faqs">
      <div className="head-title">Frequently Asked Questions</div>
      <Divider sx={{ mt: 1 }} />
      <div className="faqs-content">
        <Grid container spacing={2}>
          <Grid
            item
            xs={false}
            sm={false}
            md={3}
            lg={3}
            display={{ xs: "none", sm: "none", lg: "block", md: "block" }}
          >
            <Stack spacing={2} className="faqs-list-titles">
              {FAQs_Data.map((item) => (
                <a href={item.href} className="title" key={item.id}>
                  {item.title}
                </a>
              ))}
            </Stack>
          </Grid>
          <Grid item xs={12} sm={12} md={9} lg={9}>
            <div className="faqs-list-container">
              {FAQs_Data.map((item) => (
                <div id={item.id} key={item.id} className="single-faq">
                  <div className="title">
                    <b>{item.title}</b>
                  </div>
                  <div className="questions-container">
                    {item.questions.map((QA) => (
                      <QuestionsAnswer key={QA.id} QA={QA} />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default Faqs;
